export default __webpack_public_path__ + "static/media/file.e59a5217.svg";